import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { DoloresSection } from '../components/sections/DoloresSection';
import { BeneficiosSection } from '../components/sections/BeneficiosSection';
import { RecipeCategoriesSection } from '../components/sections/RecipeCategoriesSection';
import { BonusSection } from '../components/sections/BonusSection';
import { PriceSection } from '../components/sections/PriceSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { ReviewsSection } from '../components/sections/ReviewsSection';
import { FAQSection } from '../components/sections/FAQSection';
import { SectionDivider } from '../components/SectionDivider';
import { UrgencyBar } from '../components/UrgencyBar';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-ancestral-cream font-sans text-ancestral-dark" data-id="element-344">
      {/* Barra de urgencia sticky */}
      <UrgencyBar data-id="element-345" />

      {/* A) Promesa */}
      <HeroSection data-id="element-346" />

      {/* B) Dolores */}
      <DoloresSection data-id="element-347" />

      {/* C) Beneficios */}
      <BeneficiosSection data-id="element-348" />

      {/* D) ¿Qué obtengo de este libro? */}
      <RecipeCategoriesSection data-id="element-349" />

      {/* D.5) Bonos de regalo */}
      <BonusSection data-id="element-350" />

      {/* E) Precio */}
      <PriceSection data-id="element-351" />

      {/* F) Garantía */}
      <GuaranteeSection data-id="element-352" />

      {/* F.5) Reseñas */}
      <ReviewsSection data-id="element-353" />
      <SectionDivider color="green" className="bg-ancestral-cream" data-id="element-354" />

      {/* G) Preguntas Frecuentes */}
      <FAQSection data-id="element-355" />
    </main>;
}